import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class IsfSynchronizationRepository {
  constructor(private apiService: ApiService) {}

  public bond(id: number): Observable<never> {
    return this.apiService.post(`${environment.url.prefixCustoms}v2/management/isfs/${id}/sync/bond`);
  }

  public providerConnection(id: number): Observable<never> {
    return this.apiService.post<never>(`${environment.url.isfManagement}${id}/sync/provider-connection`);
  }
}
